import { UPLOAD_FILE_API } from 'api/config';
import { updateOne } from 'api/speciesApi';
import { getWindowConfig } from 'config';
import PropTypes from 'prop-types';
import Message from 'rc-message';
import Upload from 'rc-upload';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';
import Permissions from 'react-redux-permissions';
import _ from 'lodash';

const UploadImage = styled.div`
  width: 146px;
  height: 172px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TextUpload = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #d0d8e2;
`;

const ImageUploaded = styled.div`
  .bp3-icon-trash {
    display: none;
  }
  &:hover {
    img {
      filter: brightness(50%);
    }
    .bp3-icon-trash {
      display: inline-block;
    }
  }
`;

@connect((state) => ({
  token: state.auth.token,
  permissions: state.permissions,
}))
export default class UploadImageComponent extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.uploaderProps = {
      action: UPLOAD_FILE_API(),
      headers: {
        Authorization: this.props.token,
      },
      beforeUpload: (file) => {
        if (file.size > 5242880) {
          Message.error({ content: 'Hình ảnh phải nhỏ hơn 5MB!' });
          return false;
        }
      },
      onSuccess: (res) => {
        this.setState({
          imageName: res.file.filename,
          res: res,
        });
        if (this.props.onSuccess) this.props.onSuccess(res);
      },
      onProgress: (step, file) => {},
      onError: (err) => {},
    };
    this.state = {
      destroyed: false,
      imageName: this.props.name,
      isClickDelete: false,
      imageUrl: props.value,
      isDeleteRole: false,
    };
  }

  uploadImage = async () => {
    const { speciesID } = this.props;
    const { imageName } = this.state;

    const res = await updateOne(speciesID, {
      AvatarUrl: getWindowConfig().storagePath + imageName,
    });

    if (res.success) {
      this.setState({
        imageUrl: getWindowConfig().storagePath + imageName,
        isClickDelete: true,
      });
      window.location.reload();
    }
    if (res.error) console.log('Fail');
  };

  deleteImage = async () => {
    const { speciesID } = this.props;

    const res = await updateOne(speciesID, {
      AvatarUrl: null,
    });

    if (res.success) {
      this.setState({
        imageUrl: undefined,
      });
      Message.success({ content: 'Xóa hình ảnh thành công!' });
      window.location.reload();
    }
    if (res.error) Message.error({ content: 'Xóa hình ảnh không thành công!' });
  };

  componentDidMount = () => {
    const { value } = this.props;

    this.setState({ imageUrl: value });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { imageName } = this.state;

    if (prevState.imageName !== imageName) {
      this.uploadImage();
    }
  };

  getRole = () => {
    const { permissions } = this.props;

    if (
      ['biodiversity.view', 'biodiversity.write'].every((element) =>
        permissions.includes(element)
      )
    )
      return true;
    return false;
  };

  render() {
    const { imageUrl } = this.state;
    const { value, token } = this.props;

    return (
      <Upload
        {...this.uploaderProps}
        Component='div'
        accept='.jpg,.jpeg,.svg,.png'
        disabled={!_.isNil(imageUrl) || !this.getRole()}
      >
        <div
          style={
            value === undefined || value === null || imageUrl === undefined
              ? {}
              : { display: 'none' }
          }
        >
          <Permissions allowed={['biodiversity.write', 'biodiversity.view']}>
            <Fragment>
              <UploadImage>
                <Permissions allowed={['biodiversity.write']}>
                  <Fragment>
                    <Icon
                      ref={this.permissionRef}
                      icon={'plus'}
                      iconSize={50}
                      style={{ color: '#D0D8E2' }}
                    />
                    <TextUpload>Upload</TextUpload>
                  </Fragment>
                </Permissions>
              </UploadImage>
            </Fragment>
          </Permissions>
        </div>
        {imageUrl && (
          <ImageUploaded>
            <img
              style={{ width: '146px', height: '172px' }}
              alt=''
              src={`${imageUrl}?token=${token}`}
            />
            <Permissions allowed={[`biodiversity.write`]}>
              <Fragment>
                <div onClick={this.deleteImage}>
                  <Icon
                    icon={'trash'}
                    iconSize={20}
                    style={{
                      color: '#FFFFFFD7',
                      position: 'absolute',
                      top: 115,
                      left: 85,
                    }}
                  />
                </div>
              </Fragment>
            </Permissions>
          </ImageUploaded>
        )}
      </Upload>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/upload-image/index.js